import { ICostCenterAM, CostCenter } from "../../cost-centers/cost-center-api";
import * as moment from 'moment';

export class CostCenterDateEdit{

    

    constructor(private costCenter: ICostCenterAM) {

        if(!this.costCenter){
            this.costCenter = new CostCenter({ identifier: null, name: null, activeFrom: null, activeUntil: null });
        }
    }

    setCostCenter(costCenter: ICostCenterAM){
        this.costCenter = costCenter;
    }

    get isActiveFromSet(): boolean{
		return !!this.costCenter.activeFrom;
	}
	
	set isActiveFromSet(value : boolean){
		if(value){
			const year = moment().year() + 1;
			this.costCenter.activeFrom = new Date(year, 0, 1);
		} 
		else {
			this.costCenter.activeFrom = null;
		}
	}

	get isActiveUntilSet(): boolean{
		return !!this.costCenter.activeUntil;
	}

	set isActiveUntilSet(value : boolean){
		if(value){
			const year = moment().year();
			this.costCenter.activeUntil = new Date(year, 11, 31);
		} 
		else {
			this.costCenter.activeUntil = null;
		}
	}

}